<template>
    <v-dialog
      v-model="dialog"
      max-width="500px">
      <v-card class="px-4 pt-4 pb-2">
        <v-card-text>
          <v-layout column xs12 text-xs-center>
            <v-flex>
              <v-icon :style="iconStyle" class="amber--text lighten-1">
                fas fa-exclamation-triangle
              </v-icon>
            </v-flex>
            <v-flex :class="contentClass">
              <slot name="content"></slot>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pr-2">
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" flat @click="dialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

export default {
  props: {
    contentClass: {
      type: String,
      default: '',
    },
    iconStyle: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    show(value) {
      this.dialog = value;
    },
    dialog() {
      if (!this.dialog) {
        this.$emit('close');
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/global/AlertModal.vue